import React, { Component } from "react";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import FormGroup from "@material-ui/core/FormGroup";
import TableHead from "@material-ui/core/TableHead";
import Divider from "@material-ui/core/Divider";
import { withStyles } from "@material-ui/core/styles";
import { withTranslation } from "react-i18next";
import { getErrorString } from "../display/ErrorStrings";

import DeselectIcon from "@material-ui/icons/BackspaceOutlined";
import ApproveIcon from "@material-ui/icons/CheckBoxOutlined";
import DenyIcon from "@material-ui/icons/CancelOutlined";

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },
});

class UploadedFileDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      totalItems: 0,
      errorString: "",
      items: [],
    };
    this.onClose = this.onClose.bind(this);
  }

  componentDidMount() {
    /*let myUrl = 'on_uploaded_file_details_request?transit=' +
			this.props.accountObject.transit +
			'&account=' + this.props.accountObject.account +
			'&importId=' + encodeURIComponent(this.props.item.importId) +
			'&r=' + new Date().getTime() +
			'&token=' + this.props.secureToken;*/
    let myUrl = "on_uploaded_file_details_request";

    fetch(myUrl, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        r: new Date().getTime(),
        secureToken: this.props.secureToken,
        transit: this.props.accountObject.transit,
        account: this.props.accountObject.account,
        importId: this.props.item.importId,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (reply.authenticated === false) {
          this.props.history.push("/expired");
        } else {
          if (reply.error) {
            this.setState({ errorString: reply.errorString });
          } else {
            this.setState({ totalItems: reply.totalCount });
            this.setState({ items: reply.items });
          }
        }
      })
      .catch((error) => {
        this.setState({ waiting: false });
        this.setState({ totalCount: 0 });
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
      });
  }

  onClose(e) {
    e.preventDefault();
    this.props.onClosePopup(e);
  }

  handleDisposition(e, accepted) {
    let myImportIds = new Array(1);
    myImportIds[0] = this.props.item.importId;
    fetch("on_uploaded_items_disposition", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        transit: this.props.accountObject.transit,
        account: this.props.accountObject.account,
        approval: accepted,
        importIds: myImportIds,
        secureToken: this.props.secureToken,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (!reply.authenticated) {
          this.props.history.push("/expired");
        } else if (reply.error) {
          this.setState({ errorString: reply.errorString });
        } else {
          this.props.onItemDisposition(e);
        }
      })
      .catch((error) => {
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
      });
  }

  render() {
    const { classes } = this.props;
    let data = this.state.items;
    let { t } = this.props;
    return (
      <div>
        <Paper elevation={5}>
          <FormGroup row>
            <Typography variant="headline" color="textSecondary">
              &nbsp;&nbsp; {t("selectFile.label")}
              &nbsp;&nbsp;
            </Typography>
            <Button onClick={this.onClose} color="primary">
              <DeselectIcon />
              &nbsp;{t("deselect.button")}
            </Button>
            {this.state.errorString.length === 0 && (
              <Button
                onClick={(event) => this.handleDisposition(event, true)}
                color="primary"
              >
                <ApproveIcon />
                &nbsp;{t("approve.button")}
              </Button>
            )}
            {this.state.errorString.length === 0 && (
              <Button
                onClick={(event) => this.handleDisposition(event, false)}
                color="primary"
              >
                <DenyIcon />
                &nbsp;{t("deny.button")}
              </Button>
            )}
          </FormGroup>
          <Divider />
          {this.state.errorString.length > 0 && (
            <h3 style={{ color: "red" }}> {this.state.errorString} </h3>
          )}
          {this.state.errorString.length === 0 &&
            this.state.totalItems === 0 && (
              <h3>
                {" "}
                {getErrorString(
                  "general.info.search.empty",
                  t("totalZero.label")
                )}{" "}
              </h3>
            )}
          {this.state.errorString.length === 0 && this.state.totalItems > 0 && (
            <Table
              className={classes.table}
              aria-labelledby="tableTitle"
              stickyHeader
            >
              <TableHead>
                <TableRow>
                  <TableCell>{t("date.header")}</TableCell>
                  <TableCell>{t("status.header")}</TableCell>
                  <TableCell numeric={true}>
                    {t("checkNumber.header")}
                  </TableCell>
                  <TableCell numeric={true}>{t("amount.header")}</TableCell>
                  <TableCell>{t("payee.header")}</TableCell>
                  <TableCell>{t("importDate.header")}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data.map((n) => {
                  return (
                    <TableRow key={n.index}>
                      <TableCell>{n.date}</TableCell>
                      <TableCell>{n.status}</TableCell>
                      <TableCell numeric={true}>{n.checkNumber}</TableCell>
                      <TableCell numeric={true}>{n.amount}</TableCell>
                      <TableCell
                        style={{ width: "40%", wordWrap: "break-word" }}
                      >
                        {n.payee}
                      </TableCell>
                      <TableCell>{n.importDate}</TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          )}
        </Paper>
      </div>
    );
  }
}

export default withTranslation()(withStyles(styles)(UploadedFileDetails));
